import Balancer from "react-wrap-balancer";
import { Calendar } from "@/icons";
import "./CardReminder.scss";
import { HeadingLevel } from "@/types/headings";

type CardReminderProps = {
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  titleTag?: HeadingLevel;
  footer?: React.ReactNode;
};

export const CardReminder = ({
  icon = <Calendar width={21} height={21} color="slate-28" />,
  titleTag: TitleTag = "h1",
  title,
  description,
  footer,
}: CardReminderProps) => {
  return (
    <div className="bg-white shadow br-x4 ui-card-reminder">
      <header className="ui-card-reminder-header">
        <div className="ui-card-reminder-icon">{icon}</div>
        <TitleTag className="fs-5 md-fs-4 fw-semibold text-slate-28">
          {title}
        </TitleTag>
      </header>
      {description && (
        <Balancer
          as="p"
          className="fs-custom fw-regular text-slate-28 ui-card-reminder-content"
        >
          {description}
        </Balancer>
      )}
      {footer && <footer className="ui-card-reminder-footer">{footer}</footer>}
    </div>
  );
};
